import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m13.649 8.248-1.637-1.626 1.525-1.517 1.636 1.627A1.081 1.081 0 0 0 17 5.97a1.07 1.07 0 0 0-.303-.754l-1.635-1.628.761-.755a1.07 1.07 0 0 0 .003-1.518 1.082 1.082 0 0 0-1.526-.002L6.565 9.005a3.79 3.79 0 0 0-4.818 1.06 3.738 3.738 0 0 0 .359 4.896 3.786 3.786 0 0 0 4.922.354 3.734 3.734 0 0 0 1.063-4.793l2.4-2.385 1.633 1.63a1.08 1.08 0 0 0 1.84-.759 1.067 1.067 0 0 0-.315-.758v-.002Z",
  stroke: "#0F6378",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.779 13.64c.744 0 1.348-.6 1.348-1.34 0-.74-.604-1.341-1.348-1.341-.744 0-1.347.6-1.347 1.34 0 .74.603 1.34 1.347 1.34Z",
  stroke: "#0F6378",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }